export const MAX_INVALID_PASSWORD_ATTEMPTS = 3